export function loadStoredData({ commit }){
    // load data from local storage and login
    
    commit('LOAD_USER_STORED');
    commit('LOAD_SCHOOLS');

   // dispatch('autoLogin', payload);
  }